<template>
  <div class="page-content-inner pt-lg-0  pr-lg-0 mt-4">
    <h3>{{ $t('education.catalog_education') }}</h3>
    <div v-if="errorMessages?.length" class="uk-alert-danger" uk-alert>
      <template v-for="(error, index) in errorMessages">
        <span v-if="error != null" :key="index">
          <a class="uk-alert-close" uk-close></a>
          <p class="m-0" style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </span>
      </template>
    </div>
    <div v-if="successMessage" class="uk-alert-success" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color: green">
        <i class="uil-exclamation-triangle"></i> {{ successMessage }}
      </p>
    </div>
    <div v-if="!defaultLoadingModal" class="catalog-search-bar">
      <div class="catalog-search-bar__input-wrap">
        <input v-model="searchQuery" :placeholder="$t('home.Education_shearing')" class="catalog-search-bar__input"
               type="text"
               @input="isTyping = true">
      </div>
      <label class="catalog-page-size">
        <span>{{ $t('education.education') }}</span>
        <select v-model.number="filters.perPage" @change="changeCatalogPageSize">
          <option :value="10">10</option><option :value="50">50</option><option :value="100">100</option>
        </select>
      </label>
      <div class="catalog-search-bar__sort-wrap">
        <MultipleSelectInput v-model="selectedSort"
                             :allow-empty="false"
                             :searchable="false"
                             :show-labels="false"
                             :values="sortOptions"
                             class="catalog-search-bar__select"
                             label="name"
                             track-by="id"
        />
      </div>
    </div>

    <!-- Mobile filter tabs (outside grid for full-width) -->
    <CatalogFilterTabs v-if="!defaultLoadingModal"
                       :categories="educationTypes"
                       :selected-categories.sync="options"
                       :selected-types.sync="kinds"
                       :types="formattedTrainingKind"
    />

    <div v-if="!defaultLoadingModal" class="ro" uk-grid>
      <!-- Desktop sidebar -->
      <div class="uk-width-1-3@m catalog-sidebar-desktop">
        <nav class="responsive-tab style-3 setting-menu card"
             uk-sticky="top:30 ; offset:100; media:@m ;bottom:true; animation: uk-animation-slide-bottom">
          <ul class="side-list" uk-accordion>
            <li class="">
              <a class="uk-accordion-title" href="#"><i class="uil-book-alt"></i> {{ $t('home.Categories') }}</a>
              <div class="uk-accordion-content">
                <ul class="ks-cboxtags">
                  <li v-for="(item, index) in educationTypes" :key="'cat-d-' + index">
                    <input :id="'checkboxCatD_' + index" v-model="options" :value="item.id" type="checkbox">
                    <label :for="'checkboxCatD_' + index">
                      {{ item.name }}
                    </label>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a class="uk-accordion-title" href="#"><i class="uil-notes"></i> {{ $t('general.training_types') }}</a>
              <div class="uk-accordion-content">
                <ul class="ks-cboxtags">
                  <li>
                    <input id="checkboxTypeOneD" v-model="kinds" :value="0" checked type="checkbox">
                    <label for="checkboxTypeOneD">{{ $t('general.all') }}</label>
                  </li>
                  <li v-for="(item, index) in formattedTrainingKind" :key="'kind-d-' + index">
                    <input :id="'checkboxKindD_' + index" v-model="kinds" :value="item.id" type="checkbox">
                    <label :for="'checkboxKindD_' + index">
                      {{ item.name }}
                    </label>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </nav>
      </div>

      <!--super admin için-->
      <div v-if="superAdmin()" class="uk-width-2-3@m">
        <div class="card rounded">
          <div class="catalog-list-header">
            <h5 class="catalog-list-header__title"> {{ selected_type.name }}
              <span class="catalog-list-header__count">({{
                  itemsDisplay ? itemsDisplay.total : 0
                }} {{ $t('education.education') }} {{ $t('general.being_displayed') }})</span>
            </h5>
            <div class="catalog-list-header__actions">
              <button class="btn btn-sm btn-soft-secondary catalog-list-header__btn" type="button"
                      @click="allUserToggle()">
                <i class="uil-check-square"></i> {{ selectAllTrainingText }}
              </button>
              <button :class="{ 'disabled': training_ids?.length === 0 }"
                      class="btn btn-success catalog-list-header__btn" @click="openLicenceModal()">
                <i class="uil-location-arrow"></i> {{ $t('general.license_selected') }}
              </button>
              <div id="modal_catalog_add" class=" uk-modal" uk-modal="">

                <div class="uk-modal-dialog" style="width:100%">

                  <button class="uk-modal-close-default" type="button" uk-close></button>
                  <div class="uk-modal-header">
                    <h2 class="uk-modal-title">{{
                        $t('general.licensing_educations_selected', {
                          count:
                          training_ids?.length
                        })
                      }}</h2>
                  </div>
                  <div class="card">
                    <div v-if="errorMessages?.length" class="uk-alert-danger" uk-alert>

                      <template v-for="(error, index) in errorMessages">
                        <span v-if="error != null" :key="index">
                          <a class="uk-alert-close" uk-close></a>
                          <p class="m-0" style="color: red">
                            <i class="uil-exclamation-triangle"></i> {{ error }}
                          </p>
                        </span>
                      </template>
                    </div>
                    <div v-if="successMessage" class="uk-alert-success" uk-alert>
                      <a class="uk-alert-close" uk-close></a>
                      <p style="color: green">
                        <i class="uil-exclamation-triangle"></i> {{ successMessage }}
                      </p>
                    </div>
                    <!-- Card header -->
                    <div class="card-header actions-toolbar border-0">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="row" style="width:100%">
                          <div class=" col-md-1  search-icon ">
                            <i class="uil-search"></i>
                          </div>
                          <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                            <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                                   class="uk-search-input shadow-0 uk-form-small" type="search" @change="filterResult"/>
                          </div>
                        </div>
                        <div class="d-flex">
                          <!-- Shorting -->
                          <MultipleSelectInput v-model="selectedModalSort"
                                               :allow-empty="false"
                                               :searchable="false"
                                               :show-labels="false"
                                               :values="modalSortOptions"
                                               class="catalog-modal-sort"
                                               label="name"
                                               track-by="id"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Table -->
                  <div class="table-responsive">
                    <table class="table align-items-center">
                      <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('institution.list.company_name') }}</th>
                        <th scope="col">{{ $t('institution.list.contract_expired_date') }}</th>
                        <th scope="col">{{ $t('institution.list.created_at') }}</th>
                        <th scope="col">{{ $t('general.number_of_users') }}</th>
                        <th scope="col"></th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <!--user item-->
                      <tr v-for="institution in formattedItem">
                        <th>
                          <div style="display:flex;justify-content:center">
                            <input v-if="training_ids?.length > 1" :id="'notification_checkbox_' + institution.id"
                                   v-model="company_ids" :value="institution.id" style="margin: 0px 0px 0px 10px"
                                   type="radio">
                            <input v-if="training_ids?.length < 2" :id="'notification_checkbox_' + institution.id"
                                   v-model="company_ids" :value="institution.id" style="margin: 0px 0px 0px 0px"
                                   type="checkbox"/>
                          </div>
                        </th>
                        <th scope="row">
                          <div class="media align-items-center">
                            <div>
                              <div class="avatar-parent-child" style="width: max-content">
                                <img :src="institution.logo_link" alt="Image placeholder"
                                     class="avatar  rounded-circle">
                              </div>
                            </div>
                            <div class="media-body ml-4">
                              <a class="name h6 mb-0 text-sm">{{ institution.name }}</a>
                              <small class="d-block font-weight-bold">#{{ institution.id }}</small>
                            </div>
                          </div>
                        </th>
                        <td>{{ institution.end_date }}</td>
                        <td> {{ institution.created_at }}</td>
                        <td> {{ institution.users_count }}</td>

                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <pagination :page.sync="pageProxy" :pagination="pagination" @changePage="setPage($event)">
                  </pagination>
                  <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-default uk-modal-close" type="button">{{
                        $t('general.give_up')
                      }}
                    </button>
                    <button class="uk-button uk-button-primary ml-2" type="button" @click="saveCheckedInstitution()"> {{
                        $t("general.save")
                      }}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <template v-for="(subItem, index) in itemsDisplay.data"
                    v-if="itemsDisplay && itemsDisplay.data && itemsDisplay.data?.length">
            <hr class="m-0">
            <div class="catalog-card position-relative">
              <div v-if="subItem.self_registrable_trainings?.length > 0
                && subItem.company_id === 1" class="ribbon ribbon-top-left" style="height:50%">
                <span>{{ $t('general.rented') }}</span>
              </div>
              <div v-if="subItem.self_registrable_trainings?.length > 0 && subItem.company_id !== 1"
                   class="ribbon ribbon-top-left" style="height:50%">
                <span>{{ $t('general.education') }}</span>
              </div>
              <div class="catalog-card__row">
                <label class="catalog-card__check">
                  <input :id="'notification_checkbox_' + subItem.id" v-model="training_ids" :value="subItem.id"
                         :aria-label="subItem.name" type="checkbox"/>
                </label>
                <div class="catalog-card__image">
                  <img :src="subItem.cover_image_link" alt="" class="rounded card-cover-image">
                </div>
                <div class="catalog-card__info">
                  <div class="catalog-card__header">
                    <h5 class="catalog-card__title">
                      {{ subItem.name }}
                      <span v-if="subItem.catalog_anz_education_id"
                            class="catalog-card__badge catalog-card__badge--catalog">{{
                          $t('general.pulled_from_catalog')
                        }}</span>
                      <span v-if="subItem.company_id !== 1" class="catalog-card__badge catalog-card__badge--catalog">{{
                          $t('general.institution_education')
                        }}</span>
                    </h5>
                    <div class="catalog-card__actions">
                      <a v-if="!subItem.show_to_user" :uk-tooltip="$t('general.companies_not_seeing')"
                         class="btn btn-outline-danger btn-sm catalog-card__action-btn" href="javascript:void(0)"
                         @click="changeStatus(subItem.id)"><i class="uil-eye-slash"></i></a>
                      <a v-else :uk-tooltip="$t('general.companies_seeing')"
                         class="btn btn-outline-success btn-sm catalog-card__action-btn" href="javascript:void(0)"
                         @click="changeStatus(subItem.id)"><i class="uil-eye"></i></a>
                      <a :uk-tooltip="`title: ${$t('general.edit')}; pos: bottom`"
                         class="btn btn-icon btn-hover btn-sm btn-circle catalog-card__action-btn"
                         href="javascript:void(0)"
                         @click="handleOnClickCard('goEditPage', subItem.id)"><i class="uil-edit"></i></a>
                      <a :uk-tooltip="`title: ${$t('general.delete')}; pos: bottom`"
                         class="btn btn-icon btn-hover btn-sm btn-circle catalog-card__action-btn"
                         href="javascript:void(0)"
                         @click="handleOnDeleteCard(subItem.id, subItem.has_been_assigned)"><i
                          class="uil-trash text-danger"></i></a>
                    </div>
                  </div>
                  <p class="catalog-card__meta">
                    <span class="bg-light p-2"> {{
                        $t('education.section_count', { 'number': subItem.training_content_count }) + ' / ' +
                        $t('education.content_count', { 'number': subItem.training_content_count })
                      }}</span>
                  </p>
                  <p class="catalog-card__desc">{{ subItem.description }}</p>
                  <p class="catalog-card__type">{{ subItem.training_type?.name }}</p>
                </div>
              </div>
            </div>
          </template>
        </div>
        <PaginationTable v-if="itemsDisplay && itemsDisplay.data && itemsDisplay.last_page !== 1" :page.sync="pageProxy"
                         :paginate="itemsDisplay">
        </PaginationTable>
      </div>
      <!--kurum admin için-->
      <div v-if="!superAdmin()" class="uk-width-2-3@m">

        <div class="card rounded">
          <div class="catalog-list-header">
            <h5 class="mb-0"> {{ selected_type.name }}
              <span style="font-weight:300;">({{
                  itemsDisplay ? itemsDisplay.total : 0
                }} {{ $t('education.education') }} {{ $t('general.being_displayed') }})</span>
            </h5>
            <div class="catalog-list-header__actions">
              <button class="btn btn-sm btn-soft-secondary catalog-list-header__btn" type="button" @click="toggleBulkTrainings">
                {{ allVisibleBulkTrainingsSelected ? $t('general.deselect_all') : $t('general.select_all') }}
              </button>
              <button class="btn btn-primary catalog-list-header__btn" type="button"
                :disabled="!self_registrable_training_ids.length" @click="openBulkUserModal">
                {{ $t('general.bulk_assign_to_users') }} ({{ self_registrable_training_ids.length }})
              </button>
            </div>
          </div>
          <div v-for="subItem in itemsDisplay.data" :key="subItem.id">
            <hr class="m-0">
            <div class="catalog-card position-relative">
              <div v-if="subItem.self_registrable_trainings?.length > 0" class="ribbon ribbon-top-left"
                   style="z-index:1;">
                <span>{{ $t('general.rented') }}</span>
              </div>
              <div v-if="subItem.company_id === userInfo?.company_id" class="ribbon ribbon-top-left" style="z-index:1;">
                <span>{{ $t('general.education') }}</span>
              </div>
              <div class="catalog-card__row">
                <label class="catalog-card__check">
                  <input :checked="self_registrable_training_ids.includes(subItem.id)"
                    @change="setBulkTrainingSelected(subItem.id, $event.target.checked)" :id="'bulk_training_' + subItem.id"
                    :value="subItem.id" :aria-label="subItem.name" type="checkbox" />
                </label>
                <div class="catalog-card__image">
                  <img :src="subItem.cover_image_link" alt="" class="rounded card-cover-image">
                </div>
                <div class="catalog-card__info">
                  <h5 class="catalog-card__title">{{ subItem.name }}</h5>
                  <p class="catalog-card__meta">
                    <span class="bg-light"> {{
                        $t('education.section_count', { 'number': subItem.training_content_count }) + ' / ' +
                        $t('education.content_count', { 'number': subItem.training_content_count })
                      }}</span>
                  </p>
                  <p class="catalog-card__desc">{{ subItem.description }}</p>
                  <p class="catalog-card__type">{{ subItem.training_type?.name }}</p>
                </div>
                <div class="catalog-card__actions-col">
                  <a class="btn btn-sm btn-primary catalog-card__show-btn" href="javascript:void(0)"
                     @click="showUser(subItem.id)">
                    <i class="uil-eye"></i> {{ $t('general.show_to_users') }}
                  </a>
                  <div class="catalog-card__icon-actions">
                    <button v-if="isDemoActive(subItem)" :uk-tooltip="`title: ${$t('general.preview')}; pos: top-right`"
                            class="catalog-card__icon-btn catalog-card__icon-btn--preview" type="button"
                            @click="handleOnClickCard('goDemoPage', subItem.id)">
                      <i class="uil-eye"/>
                    </button>
                    <button v-if="subItem.company_id === userInfo?.company_id"
                            :uk-tooltip="`title: ${$t('general.edit')}; pos: top-right`"
                            class="catalog-card__icon-btn catalog-card__icon-btn--edit" type="button"
                            @click="handleOnClickCard('goEditPage', subItem.id)">
                      <i class="uil-edit"/>
                    </button>
                    <button v-if="subItem.company_id === userInfo?.company_id"
                            :uk-tooltip="`title: ${$t('general.delete')}; pos: top-right`"
                            class="catalog-card__icon-btn catalog-card__icon-btn--delete" type="button"
                            @click="handleOnDeleteCard(subItem.id, subItem.has_been_assigned)">
                      <i class="uil-trash"/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PaginationTable v-if="itemsDisplay && itemsDisplay.data && itemsDisplay.last_page !== 1" :page.sync="pageProxy"
                         :paginate="itemsDisplay">
        </PaginationTable>

      </div>

      <AppModal :bottom-sheet="true" :visible.sync="bulkModalOpen" :close-on-overlay="!isBulkAssignmentLoading"
        :show-close-button="!isBulkAssignmentLoading" :title="$t('general.bulk_assign_to_users') + ' (' + bulkTrainingIds.length + ' ' + $t('education.education') + ')'"
        max-height="90vh" width="1200px">
        <div v-if="isBulkAssignmentLoading" role="status" aria-live="polite" :aria-label="$t('general.loading')">
          <default-loading min-height="320px"></default-loading>
        </div>
        <div v-show="!isBulkAssignmentLoading" class="catalog-share-content">
          <div v-if="bulkAssignmentError" class="uk-alert-danger" role="alert">{{ bulkAssignmentError }}</div>
          <label class="catalog-all-users">
            <input v-model="bulkAllUsers" type="checkbox" :disabled="isBulkAssignmentLoading" />
            <span>{{ $t('general.all_company_users') }}</span>
          </label>
          <p v-if="bulkAllUsers" role="status">{{ $t('general.all_company_users_will_be_included') }}</p>
          <fieldset class="catalog-selection" :disabled="bulkAllUsers || isBulkAssignmentLoading"
            :inert="bulkAllUsers || isBulkAssignmentLoading ? '' : null"
            :class="{ 'catalog-selection--disabled': bulkAllUsers || isBulkAssignmentLoading }">
            <UserGroupSelection v-if="bulkModalOpen" :key="'bulk-users-' + bulkSelectionKey" :allow_both_selection="true"
              @setCheckedUsers="bulkUserIds = $event" @setCheckedGroups="bulkGroupIds = $event" />
          </fieldset>
        </div>
        <template #footer>
          <div class="catalog-share-footer">
            <strong><i class="uil-book-open"></i> {{ bulkTrainingIds.length }} {{ $t('education.education') }}</strong>
            <div class="catalog-share-footer__right">
              <button class="btn btn-outline-secondary catalog-share-footer__btn" type="button"
                :disabled="isBulkAssignmentLoading" @click="bulkModalOpen = false">{{ $t('general.cancel') }}</button>
              <button class="btn btn-primary catalog-share-footer__btn" type="button"
                :disabled="isBulkAssignmentLoading" @click="saveBulkUsers">
                <span v-if="isBulkAssignmentLoading" class="spinner-border spinner-border-sm mr-1"></span>
                <i v-else class="uil-plus-circle"></i> Kullanıcılara Tanımla
              </button>
            </div>
          </div>
        </template>
      </AppModal>

      <AppModal
        :bottom-sheet="true"
        :close-on-overlay="!isUserAssignmentLoading"
        :show-close-button="!isUserAssignmentLoading"
        :title="selectedTrainingName"
        :visible.sync="shareSettingsVisible"
        max-height="90vh"
        width="1200px"
        @close="closeShareSettingsModal"
      >
        <div class="catalog-share-content">
          <div v-if="userAssignmentError" class="uk-alert-danger" role="alert">{{ userAssignmentError }}</div>
          <label class="catalog-all-users">
            <input v-model="singleAllUsers" type="checkbox" :disabled="isUserAssignmentLoading" />
            <span>{{ $t('general.all_company_users') }}</span>
          </label>
          <p v-if="singleAllUsers" role="status">{{ $t('general.all_company_users_will_be_included') }}</p>
          <fieldset class="catalog-selection" :disabled="singleAllUsers || isUserAssignmentLoading"
            :inert="singleAllUsers || isUserAssignmentLoading ? '' : null"
            :class="{ 'catalog-selection--disabled': singleAllUsers || isUserAssignmentLoading }">
          <UserGroupSelection
            :allow_both_selection="true"
            :key="'user-group-' + checked_training"
            :added_groups="checked_groups"
            :added_users="checked_users"
            :case_detail="!superAdmin() ? 'usersRequestedTraining' : 'adminSelfRegistrableTraining'"
            :checked_training="checked_training"
            @setCheckedGroups="checked_groups = $event"
            @setCheckedUsers="checked_users = $event"
          />
          </fieldset>
        </div>

        <template #footer>
          <div class="catalog-share-footer">
            <button
              :disabled="isUserAssignmentLoading"
              class="btn btn-danger catalog-share-footer__btn"
              type="button"
              @click="removeCheckedUser()"
            >
              <span v-if="isUserAssignmentLoading" class="spinner-border spinner-border-sm mr-1"></span>
              <i v-else class="uil-minus-circle"></i>
              {{ $t('general.remove_from_selected_users') }}
            </button>
            <div class="catalog-share-footer__right">
              <button
                :disabled="isUserAssignmentLoading"
                class="btn btn-outline-secondary catalog-share-footer__btn"
                type="button"
                @click="closeShareSettingsModal()"
              >
                {{ $t('general.cancel') }}
              </button>
              <button
                :disabled="isUserAssignmentLoading"
                class="btn btn-primary catalog-share-footer__btn"
                type="button"
                @click="saveCheckedUser()"
              >
                <span v-if="isUserAssignmentLoading" class="spinner-border spinner-border-sm mr-1"></span>
                <i v-else class="uil-plus-circle"></i>
                {{ $t('general.add_to_selected_users') }}
              </button>
            </div>
          </div>
        </template>
      </AppModal>
    </div>
    <!-- <AddToGroupModal :title="'Kullanıcı Ekle'" @getList="getList($event)"></AddToGroupModal> -->
    <default-loading v-if="defaultLoadingModal"></default-loading>
  </div>
</template>

<script>
import EducationCard from "@/view/components/index/EducationCard";
import PaginationTable from "@/view/components/dataTable/Pagination.vue";
import Pagination from "@/assets/components/Pagination";

import moment from "moment";
import store from '@/core/services'
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import axios from "axios";

import {
  CREATE_ITEM,
  DELETE_ITEM_BY_ID,
  GET_ITEM_DETAIL_BY_ID,
  GET_ITEMS,
  LOADING,
  UPDATE_ITEM_BY_ID
} from "@/core/services/store/REST.module";
import AddToGroupModal from "@/view/company/User/Group/AddToGroupModal";
import {
  BASE_URL as TRAINING_KIND_URL,
  GET_ITEMS as GET_TRAINING_KINDS,
  ITEMS as TRAINING_KINDS,
  MODULE_NAME as MODULE_TRAINING_KIND
} from "@/core/services/store/training_kind.module";
import {
  BASE_URL as COMPANY_URL,
  GET_ITEMS as GET_COMPANY,
  ITEMS as ITEMS_COMPANY,
  MODULE_NAME as MODULE_COMPANY,
} from "@/core/services/store/company.module";
import Swal from "sweetalert2";
import UserGroupSelection from "@/view/components/assignment/UserGroupSelection";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import CatalogFilterTabs from "./components/CatalogFilterTabs.vue";
import AppModal from "@/view/components/ui/AppModal.vue";

const _TRAINING_KIND_MODULE = MODULE_TRAINING_KIND;

export default {
  name: "EducationCatalog",
  components: {
    EducationCard,
    Pagination,
    PaginationTable,
    DefaultLoading,
    UserGroupSelection,
    AddToGroupModal,
    MultipleSelectInput,
    CatalogFilterTabs,
    AppModal
  },
  beforeCreate() {
    // this.defaultLoadingModal = true;
    // function registerStoreModule(moduleName, storeModule) {
    //   if (!(store && store.state && store.state[moduleName])) {
    //     store.registerModule(moduleName, storeModule)
    //   }
    // }
    // registerStoreModule(_TRAINING_KIND_MODULE, training_kind_module)
  },
  data() {
    return {
      bulkModalOpen: false,
      bulkSelectionKey: 0,
      bulkTrainingIds: [],
      bulkUserIds: [],
      bulkGroupIds: [],
      bulkAllUsers: false,
      bulkAssignmentError: null,
      isBulkAssignmentLoading: false,
      singleAllUsers: false,
      userAssignmentError: null,
      cachedItems: null, // store verilerini ekle
      defaultLoadingModal: true,
      sortOptions: [],
      trainingUrl: "api/training/",
      trainingAssignUrl: "api/training/assign-users/",
      company_ids: [],
      selectAllTrainingText: this.$t('general.select_all'),
      search: null,
      searchQuery: "",
      isTyping: false,
      searchResult: [],
      options: [0],
      kinds: [0],
      order_by: 'name',
      sort: 'desc',
      restUrl: 'api/training',
      educationTypes: [],
      selected_type: {
        id: null,
        name: this.$t('education.all_categories')
      },
      filters: {
        page: 1,
        perPage: 10,
        search: '',
        training_type_id: 0,
        training_kind_id: 0,
        admin_page: true,
        can_show_self_registrable_trainings: true,
        order_by: null,
        sort: null
      },
      successMessage: null,
      errorMessages: [],
      selected_type_name: null,
      trainingCategoryUrl: 'api/training-type',
      page: 1,
      checked_groups: [],
      checked_users: [],
      checked_training: null,
      self_registrable_training_ids: [],
      filter: {
        search: null,
        order_by: null,
        sort: null
      },
      modalSortOptions: [],
      pagination: null,
      training_ids: [],
      allTraining: false,
      allSelfRegistrableTraining: false,
      isUserAssignmentLoading: false,
      shareSettingsVisible: false
    };
  },
  computed: {
    allVisibleBulkTrainingsSelected() {
      const trainings = this.itemsDisplay.data || [];
      return trainings.length > 0 && trainings.every(training => this.self_registrable_training_ids.includes(training.id));
    },
    itemsDisplay() {
      // Eğer cachedItems varsa onu kullan, yoksa ve store'da items varsa onu kullan
      if (this.cachedItems && this.cachedItems.data && Array.isArray(this.cachedItems.data)) {
        return this.cachedItems;
      }
      const storeItems = store.getters[_TRAINING_KIND_MODULE + '/' + TRAINING_KINDS];
      return storeItems || { data: [] };
    },
    userInfo: {
      get: function () {
        return JSON.parse(this.secureLocalStorage("user"));
      }
    },
    institutions: {
      get() {
        return store.getters[MODULE_COMPANY + '/' + ITEMS_COMPANY]
      },
      set(value) {
      }
    },
    formattedItem() {
      let results = [];
      if (this.institutions === null || !("data" in this.institutions)) return [];
      for (let i = 0; i < this.institutions.data?.length; i++) {
        let currentItem = this.institutions.data[i];
        this.pagination = this.institutions;
        if (currentItem) {
          results.push({
            id: currentItem.id,
            logo_link: currentItem.logo_link,
            name: currentItem.name,
            status_id: currentItem.status_id,
            users_count: currentItem.users_count,
            created_at: currentItem.created_at ? moment(currentItem.created_at).format('DD/MM/YYYY HH:mm:ss') : '-',
            end_date: (currentItem.contract) ? currentItem.contract.end_date : "-"
          });
        }
      }
      return results;
    },
    catalog_loading() {
      return store.getters[_TRAINING_KIND_MODULE + '/' + LOADING];
    },
    training_kinds: {
      get() {
        return store.getters[_TRAINING_KIND_MODULE + '/' + TRAINING_KINDS]
      },
      set(value) {
      }
    },
    formattedTrainingKind() {
      let results = [];
      if (!this.training_kinds) return [];
      if (this.training_kinds === null || !("data" in this.training_kinds)) return [];
      this.training_kinds.data.forEach(item => {
        results.push({
          id: item.id,
          value: item.id,
          name: item.name
        });
      });
      return results;
    },
    pageProxy: {
      set(value) {
        this.page = Number(value);
        this.$set(this.filters, 'page', this.page);
        this.refreshCatalogList();
      },
      get() {
        return this.page;
      }
    },
    user_header: {
      get() {
        return JSON.parse(this.secureLocalStorage("user"));
      },
      set() {
      },
    },
    selectedTrainingName() {
      if (!this.checked_training || !this.itemsDisplay?.data) return this.$t('general.user_and_groups');
      const training = this.itemsDisplay.data.find(item => item.id === this.checked_training);
      return training ? training.name : this.$t('general.user_and_groups');
    },
    selectedSort: {
      get() {
        const key = `${this.order_by}_${this.sort}`;
        return this.sortOptions.find(opt => opt.id === key) || null;
      },
      set(value) {
        if (value) {
          const lastUnderscoreIndex = value.id.lastIndexOf('_');
          const order_by = value.id.substring(0, lastUnderscoreIndex);
          const sort = value.id.substring(lastUnderscoreIndex + 1);
          this.order_by = order_by;
          this.sort = sort;
          this.debouncedApplyFilter();
        }
      }
    },
    selectedModalSort: {
      get() {
        const key = `${this.filter.order_by}_${this.filter.sort}`;
        return this.modalSortOptions.find(opt => opt.id === key) || null;
      },
      set(value) {
        if (value) {
          const lastUnderscoreIndex = value.id.lastIndexOf('_');
          const order_by = value.id.substring(0, lastUnderscoreIndex);
          const sort = value.id.substring(lastUnderscoreIndex + 1);
          this.filter.order_by = order_by;
          this.filter.sort = sort;
          this.filterResult();
        }
      }
    }
  },
  methods: {
    changeCatalogPageSize() {
      this.page = 1;
      this.$set(this.filters, 'page', 1);
      return this.refreshCatalogList();
    },
    async refreshCatalogList() {
      const result = await this.$store.dispatch(GET_ITEMS, {
        url: this.restUrl, acceptPromise: true, showLoading: false, filters: { ...this.filters },
      });
      if (result && result.status && result.data) this.cachedItems = result.data;
      return result;
    },
    setBulkTrainingSelected(id, checked) {
      this.self_registrable_training_ids = checked
        ? [...new Set([...this.self_registrable_training_ids, id])]
        : this.self_registrable_training_ids.filter(trainingId => trainingId !== id);
    },
    toggleBulkTrainings() {
      const ids = (this.itemsDisplay.data || []).map(training => training.id);
      this.self_registrable_training_ids = this.allVisibleBulkTrainingsSelected
        ? this.self_registrable_training_ids.filter(id => !ids.includes(id))
        : [...new Set([...this.self_registrable_training_ids, ...ids])];
    },
    openBulkUserModal() {
      if (!this.self_registrable_training_ids.length) return;
      this.bulkTrainingIds = [...this.self_registrable_training_ids];
      this.bulkUserIds = [];
      this.bulkGroupIds = [];
      this.bulkAllUsers = false;
      this.bulkAssignmentError = null;
      this.bulkSelectionKey += 1;
      this.bulkModalOpen = true;
    },
    async saveBulkUsers() {
      if (this.isBulkAssignmentLoading || !this.bulkTrainingIds.length) return;
      this.bulkAssignmentError = null;
      if (!this.bulkAllUsers && !this.bulkUserIds.length && !this.bulkGroupIds.length) {
        this.bulkAssignmentError = this.$t('general.please_select_at_least_one_user');
        return;
      }
      this.isBulkAssignmentLoading = true;
      try {
        const result = await this.$store.dispatch(CREATE_ITEM, {
          url: 'api/trainings/mass/user-self-register-trainings', acceptPromise: true,
          contents: { training_ids: [...this.bulkTrainingIds], user_ids: this.bulkAllUsers ? 'all' : [...this.bulkUserIds],
            group_ids: [...this.bulkGroupIds], is_detached: false },
        });
        if (!result || !result.status) throw new Error('Assignment failed');
        this.self_registrable_training_ids = this.self_registrable_training_ids.filter(id => !this.bulkTrainingIds.includes(id));
        this.bulkModalOpen = false;
        Swal.fire({ icon: 'success', title: this.$t('general.success'),
          text: this.$t('general.assignment_completed_successfully'), confirmButtonText: this.$t('general.ok') });
        await this.refreshCatalogList();
      } catch (error) {
        this.bulkAssignmentError = 'Toplu tanımlama başarısız oldu. Lütfen tekrar deneyin.';
      } finally {
        this.isBulkAssignmentLoading = false;
      }
    },
    initializeCachedItems() {
      // İlk veri yüklemesi - başlangıç verileri
      this.$store.dispatch(GET_ITEMS, {
        url: this.restUrl,
        acceptPromise: true,
        filters: this.filters,
      }).then((response) => {
        if (response && response.status && response.data) {
          this.cachedItems = response.data;
          this.defaultLoadingModal = false;
        }
      }).catch(error => {
        console.error("Initial data load error:", error);
        this.defaultLoadingModal = false;
      });
    },
    isDemoActive(item) {
      const isDemoActive = item.training_content.some(content => content.is_demo === 1)
      return isDemoActive
    },
    getList(value) {
      let self = this
      let users_count_left = self.selected_purchase.number_of_users - self.selected_purchase.assigned_users_count;
      if (value.length > users_count_left) {
        self.scrollTop()
        self.errorMessage = this.$t('general.max_allowed_users_count', { count: users_count_left })
        return false
      }
      let formData = new FormData();
      value.forEach(item => {
        formData.append("users[]", item.id);
      })
      formData.append("purchase_id", self.selected_purchase.id);
      self.$store
          .dispatch(CREATE_ITEM, {
            url: self.trainingAssignUrl + self.selected_purchase.id,
            contents: formData,
            acceptPromise: true,
          })
          .then((result) => {
            if (!self.error) {
              // let data = result.data;
              // self.selected_purchase.assigned_users_count = data.purchase_assigned_users_count
              // self.item.total_users_allowed = data.total_users_allowed
              // self.item.assigned_users = data.assigned_users
              self.successMessage = this.$t('general.assignment_completed_successfully');
            } else self.errorMessage = self.error;
          });
    },
    settings(purchase_item) {
      this.selected_purchase = purchase_item
      this.getTrainingDetails(purchase_item.id)
    },
    getTrainingDetails(id) {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: this.trainingUrl + id,
            filters: { with_requests: true },
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) {
              this.item = result.data;
            }
          });
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    saveCheckedInstitution() {
      if (!Array.isArray(this.company_ids)) {
        this.company_ids = [this.company_ids]
      }
      let sendData = {
        'company_ids': this.company_ids,
        // 'training_ids': this.allTraining ? 'all' : this.training_ids,
        'training_ids': this.training_ids,

      }
      this.$store.dispatch(CREATE_ITEM, {
        url: 'api/self-registrable-trainings',
        contents: sendData,
        acceptPromise: true,
      })
          .then((response) => {
            this.scrollToTop();
            this.training_ids = [];
            this.selectAllTrainingText = this.$t('general.select_all');
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_created");
              this.debouncedApplyFilter()
            } else {
              this.errorMessages.push(this.error)
            }
            if (response) {
              // this.applyFilter()

              setTimeout(() => {
                this.resetMessages();
                UIkit.modal("#modal_catalog_add").hide();
                this.training_ids = [];
                this.company_ids = [];
              }, 1000);
            }
          });
    },
    superAdmin() {
      if (this.user_header === null || !("roles" in this.user_header)) {
        return false;
      }
      if (this.user_header.roles.length > 2) {
        return true;
      } else {
        return false;
      }
    },
    openLicenceModal() {
      // this.$store.dispatch(MODULE_COMPANY + '/' + GET_COMPANY, {
      //   url: COMPANY_URL,
      //   filters: {
      //     type: this.type,
      //     like: this.filter.search,
      //     page: this.page,
      //     per_page: this.per_page,
      //     order_by: this.filter.order_by,
      //     sort: this.filter.sort,
      //   }
      // }).then(response => {
      if (this.training_ids.length > 1) {
        this.company_ids = [];
      } else {
        this.itemsDisplay.data.every(item => {
          if (item.id === this.training_ids[0]) {
            this.company_ids = item.self_registrable_trainings?.reduce((acc, curr) => {
              // if (!acc.includes(curr.pivot.company_id)) {
              acc.push(curr.pivot.company_id)
              return acc;
              // }
              // return acc
            }, [])
            return false
          } else {
            return true
          }
        })
        // this.items.data.self_registrable_trainings
      }
      UIkit.modal("#modal_catalog_add").show();
    },

    filterResult() {
      this.$store.dispatch(MODULE_COMPANY + '/' + GET_COMPANY, {
        url: COMPANY_URL,
        filters: {
          type: this.type,
          like: this.filter.search,
          page: this.page,
          per_page: 6,
          order_by: this.filter.order_by,
          sort: this.filter.sort,
        }
      })
    },
    sortOrder(order_by, sort) {
      this.page = 1;
      this.filter.order_by = order_by;
      this.filter.sort = sort;

      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult()
    },
    allUserToggle() {
      if (this.selectAllTrainingText === this.$t('general.select_all')) {
        if (this.superAdmin()) {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            this.training_ids?.every((selfTraining) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                return true
              } else {
                return true
              }
            });
            if (!isSelfTraining)
              this.training_ids.push(training.id)
          });
          // this.items.data.forEach(training => this.training_ids.push(training.id))
          this.allTraining = true;
        } else {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            this.self_registrable_training_ids?.every((selfTraining) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                return true
              } else {
                return true
              }
            });
            if (!isSelfTraining)
              this.self_registrable_training_ids.push(training.id)
          });
          // this.items.data.forEach(training => this.self_registrable_training_ids.push(training.id));
          this.allSelfRegistrableTraining = true;
        }
        this.selectAllTrainingText = this.$t('general.deselect_all');
      } else {
        if (this.superAdmin()) {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            let selfIndex = 0;
            this.training_ids?.every((selfTraining, index) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                selfIndex = index;
                return true
              } else {
                return true
              }
            });
            if (isSelfTraining)
              this.training_ids.splice(selfIndex, 1);
          });
          this.allTraining = false
        } else {
          this.itemsDisplay.data.forEach((training) => {
            let isSelfTraining = false
            let selfIndex = 0;
            this.self_registrable_training_ids?.every((selfTraining, index) => {
              if (selfTraining === training.id) {
                isSelfTraining = true
                selfIndex = index;
                return true
              } else {
                return true
              }
            });
            if (isSelfTraining)
              this.self_registrable_training_ids.splice(selfIndex, 1);
          });
          this.allSelfRegistrableTraining = false;
        }
        this.selectAllTrainingText = this.$t('general.select_all');
      }
    },
    showUser(event) {
      this.checked_groups = [];
      this.singleAllUsers = false;
      this.userAssignmentError = null;
      this.checked_users = [];
      let checkedTraining = this.itemsDisplay.data.filter(data => data.id == event)
      checkedTraining[0].user_self_register_trainings.forEach(user => {
        this.checked_users.push(user.user_self_register_trainingable_id);
      });
      this.checked_training = event;
      this.shareSettingsVisible = true;
    },
    closeShareSettingsModal() {
      this.shareSettingsVisible = false;
    },
    saveCheckedUser() {
      if (!this.singleAllUsers && !this.checked_users.length && !this.checked_groups.length) {
        Swal.fire({
          icon: "warning",
          title: this.$t('general.warning'),
          text: this.$t('general.please_select_at_least_one_user'),
          confirmButtonColor: "#ae71ff",
          confirmButtonText: this.$t('general.ok'),
        });
        return;
      }
      this.submitUserAssignment({ is_detached: false });
    },
    removeCheckedUser() {
      if (!this.singleAllUsers && !this.checked_users.length && !this.checked_groups.length) {
        Swal.fire({
          icon: "warning",
          title: this.$t('general.warning'),
          text: this.$t('general.please_select_at_least_one_user_to_remove'),
          confirmButtonColor: "#ae71ff",
          confirmButtonText: this.$t('general.ok'),
        });
        return;
      }
      this.submitUserAssignment({ is_detached: true });
    },
    async submitUserAssignment({ is_detached }) {
      if (this.isUserAssignmentLoading) return;
      this.isUserAssignmentLoading = true;
      this.userAssignmentError = null;
      try {
        const contents = { user_ids: this.singleAllUsers ? 'all' : [...this.checked_users], is_detached: !!is_detached };
        const useMassAssignment = this.singleAllUsers || this.checked_groups.length > 0;
        if (useMassAssignment) {
          contents.training_ids = [this.checked_training];
          contents.group_ids = [...this.checked_groups];
        }
        const result = await this.$store.dispatch(useMassAssignment ? CREATE_ITEM : UPDATE_ITEM_BY_ID, {
          url: useMassAssignment ? 'api/trainings/mass/user-self-register-trainings'
            : 'api/trainings/' + this.checked_training + '/user-self-register-trainings',
          contents, acceptPromise: true,
        });
        if (!result || !result.status) throw new Error('Assignment failed');
        await this.refreshCatalogList();
        this.refreshCheckedUsers();
        this.closeShareSettingsModal();
        Swal.fire({ icon: 'success', title: this.$t('general.success'),
          text: this.$t('general.assignment_completed_successfully'), confirmButtonText: this.$t('general.ok') });
      } catch (error) {
        this.userAssignmentError = 'Kullanıcı işlemi başarısız oldu. Lütfen tekrar deneyin.';
      } finally {
        this.isUserAssignmentLoading = false;
      }
    },
    refreshCheckedUsers() {
      if (!this.checked_training) return;
      const checkedTraining = this.itemsDisplay.data.find(data => data.id === this.checked_training);
      // Vue reaktivitesi için önce boşalt, sonra yeni değerleri ata
      this.checked_users = [];
      this.$nextTick(() => {
        if (checkedTraining && checkedTraining.user_self_register_trainings) {
          this.checked_users = checkedTraining.user_self_register_trainings.map(
              user => user.user_self_register_trainingable_id
          );
        }
      });
    },
    changeStatus(id) {
      axios.get(`/api/set-training-visibility/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + this.secureLocalStorage("token"),
        }
      }).then(() => {
        this.debouncedApplyFilter()
      })
    },
    searchUser(searchQuery) {
      this.$set(this.filters, 'page', this.page)
      this.$set(this.filters, 'training_type_id', this.options)
      this.$set(this.filters, 'training_kind_id', this.kinds)
      this.$set(this.filters, 'search', this.searchQuery)
      this.$set(this.filters, 'order_by', this.order_by);
      this.$store.dispatch(GET_ITEMS, {
        url: this.restUrl,
        acceptPromise: false,
        filters: this.filters,
        showLoading: true,
      }).then((response) => {
        if (response) {
          this.cachedItems = response.data;
        }
      })
    },
    deleteCatalogEducation(id) {
      this.$store
          .dispatch(DELETE_ITEM_BY_ID, {
            url: this.restUrl + "/" + id,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.debouncedApplyFilter();
            } else {
              this.errorMessages.push(this.error)
            }
          });
    },
    handleOnDeleteCard(id, has_been_assigned) {
      let self = this;
      if (has_been_assigned) {
        Swal.fire({
          title: this.$t('general.confirm_delete_assigned_education'),
          icon: "question",
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.give_up'),
          confirmButtonColor: "#e31748",
        }).then((result) => {
          if (result.isConfirmed) {
            self.deleteCatalogEducation(id);
          }
        });
        return false;
      }

      Swal.fire({
        title: this.$t('general.sure_to_delete'),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.give_up'),
        confirmButtonColor: "#e31748",
      }).then((result) => {
        if (result.isConfirmed) {
          self.deleteCatalogEducation(id);
        }
      });
    },
    handleOnClickCard(event, payload) {
      if (event === 'goDemoPage') {
        this.$router.push({ name: 'company.requests.training', params: { id: payload } })
      } else if (event === 'goEditPage') {
        this.$router.push({ name: 'company.education.catalog.edit', params: { id: payload } })
      }
    },
    fixDate(value) {
      return moment().seconds(value).toNow();
    },
    applyFilter(event = null) {
      if (event?.target?.checked && event?.target?._value === 0) {
        this.kinds = [0, 1, 2, 3];
      } else if (!event?.target?.checked && event?.target?._value === 0) {
        this.kinds = [];
      }
      this.$set(this.filters, 'page', this.page)
      // this.$set(this.filters, 'training_type_id', this.selected_type.id)
      if (!(this.options.length === 1 && this.options[0] === 0)) {
        this.$set(this.filters, 'training_type_id[]', this.options)
      }
      if (!(this.kinds.length === 1 && this.kinds[0] === 0)) {
        this.$set(this.filters, 'training_kind_id[]', this.kinds)
      }
      this.$set(this.filters, 'search', this.search)
      this.$set(this.filters, 'order_by', this.order_by)
      this.$set(this.filters, 'sort', this.sort)

      // Loading state'i aktifleştir
      this.defaultLoadingModal = true;

      this.$store.dispatch(GET_ITEMS, {
        url: this.restUrl,
        acceptPromise: false,
        filters: this.filters,
      }).then((response) => {
        this.defaultLoadingModal = false
        if (response && response.data) {
          // Yanıt başarılıysa ve data varsa cache'le
          this.cachedItems = response.data;
        }
      }).catch(error => {
        console.error("API Error:", error);
        this.defaultLoadingModal = false;
      });
    },
    changeTrainingType(item = null) {
      if (item) {
        this.selected_type = item
      } else {
        this.selected_type.id = 0
        this.selected_type.name = this.$t('education.all_categories')
      }

      this.debouncedApplyFilter()
    }
  },
  watch: {
    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },
    searchQuery: _.debounce(function () {
      this.page = 1
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.searchUser(this.searchQuery);
      }
    },
    options() {
      if (this.debouncedApplyFilter) {
        this.debouncedApplyFilter();
      }
    },
    kinds() {
      if (this.debouncedApplyFilter) {
        this.debouncedApplyFilter();
      }
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
  },
  mounted() {
    this.selected_type_name = this.$t('education.all_categories')

    // Initialize sort options
    this.sortOptions = [
      { id: 'name_asc', name: this.$t('filters.order.a_z') },
      { id: 'name_desc', name: this.$t('filters.order.z_a') },
      { id: 'created_at_asc', name: this.$t('filters.order.created_at_asc') },
      { id: 'created_at_desc', name: this.$t('filters.order.created_at_desc') }
    ];

    // Initialize modal sort options
    this.modalSortOptions = [
      { id: 'name_asc', name: this.$t('filters.order.a_z') },
      { id: 'name_desc', name: this.$t('filters.order.z_a') },
      { id: 'created_at_asc', name: this.$t('filters.order.created_at_asc') },
      { id: 'created_at_desc', name: this.$t('filters.order.created_at_desc') }
    ];

    let self = this;
    store.dispatch(_TRAINING_KIND_MODULE + '/' + GET_TRAINING_KINDS, {
      url: TRAINING_KIND_URL
    });

    this.$store.dispatch(GET_ITEMS, {
      url: this.trainingCategoryUrl,
      acceptPromise: true,
    }).then(
        (response) => {
          if (response.status) {
            self.educationTypes = response.data;
            self.educationTypes.unshift({ id: 0, name: this.$t('education.all_categories') });
          }
        }
    );
    if (this.superAdmin()) {
      this.$store.dispatch(MODULE_COMPANY + '/' + GET_COMPANY, {
        url: COMPANY_URL,
        filters: {
          type: this.type,
          like: this.filter.search,
          page: this.page,
          per_page: 6,
          order_by: this.filter.order_by,
          sort: this.filter.sort,
        }
      })
    }

    this.initializeCachedItems()
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
    this.debouncedApplyFilter = _.debounce(this.applyFilter, 900);
  },
}

</script>

<style scoped>
.ribbon { pointer-events: none; }
.catalog-page-size { display: flex; align-items: center; gap: 8px; margin: 0; }
.catalog-page-size select { width: 80px; margin: 0; }
.catalog-all-users { display: inline-flex; align-items: center; gap: 10px; padding: 10px 14px;
  margin: 0 0 16px; border: 1px solid #e5e5e5; border-radius: 8px; cursor: pointer; }
.catalog-all-users input[type="checkbox"] { width: 18px; height: 18px; flex: 0 0 18px; margin: 0; padding: 0; }
.catalog-selection { min-width: 0; padding: 0; margin: 0; border: 0; }
.catalog-selection--disabled { opacity: 0.6; pointer-events: none; }

/* ─── Base ─── */
ul.ks-cboxtags li input[type=checkbox] {
  height: 100%;
}

.disabled {
  pointer-events: none;
}

/* ─── Search bar ─── */
.catalog-search-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 0;
}

.catalog-search-bar__input-wrap {
  flex: 1;
  min-width: 0;
}

.catalog-search-bar__input {
  width: 100%;
  height: 42px;
  padding: 10px 14px;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: #1e293b;
  box-sizing: border-box;
}

.catalog-search-bar__input:focus {
  border-color: var(--primaryColor, #3e416d);
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.16);
  outline: none;
}

.catalog-search-bar__sort-wrap {
  flex-shrink: 0;
  position: relative;
}

.catalog-search-bar__select {
  min-width: 200px;
}

.catalog-search-bar__select ::v-deep .multiselect {
  min-height: 42px;
  height: 42px;
  font-size: 14px;
  line-height: 1.5;
  box-sizing: border-box;
}

.catalog-search-bar__select ::v-deep .multiselect__tags {
  min-height: 42px;
  height: 42px;
  padding: 10px 40px 10px 14px;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.5;
  background: #fff;
  box-sizing: border-box;
}

.catalog-search-bar__select ::v-deep .multiselect__single {
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 0;
  padding: 0;
  color: #1e293b;
}

.catalog-search-bar__select ::v-deep .multiselect__select {
  height: 42px;
  width: 40px;
  padding: 0;
}

.catalog-search-bar__select ::v-deep .multiselect__select:before {
  top: 50%;
  transform: translateY(-50%);
}

.catalog-search-bar__select ::v-deep .multiselect__content-wrapper {
  border: 1px solid #cfd5df;
  border-radius: 10px;
  margin-top: 4px;
}

.catalog-search-bar__select ::v-deep .multiselect__option {
  font-size: 14px;
  padding: 10px 14px;
  min-height: 40px;
  line-height: 1.5;
}

.catalog-search-bar__select ::v-deep .multiselect__option--highlight {
  background: #f1f5f9;
  color: #1e293b;
}

.catalog-search-bar__select ::v-deep .multiselect__option--selected {
  background: var(--primaryColor, #3e416d);
  color: #fff;
  font-weight: 600;
}

/* ─── Modal sort dropdown ─── */
.catalog-modal-sort {
  min-width: 180px;
}

.catalog-modal-sort ::v-deep .multiselect {
  min-height: 38px;
  height: 38px;
  font-size: 13px;
}

.catalog-modal-sort ::v-deep .multiselect__tags {
  min-height: 38px;
  height: 38px;
  padding: 8px 35px 8px 12px;
  border: 1px solid #cfd5df;
  border-radius: 8px;
  font-size: 13px;
  background: #fff;
}

.catalog-modal-sort ::v-deep .multiselect__single {
  font-size: 13px;
  margin-bottom: 0;
  padding: 0;
  color: #1e293b;
}

.catalog-modal-sort ::v-deep .multiselect__select {
  height: 38px;
  width: 35px;
  padding: 0;
}

.catalog-modal-sort ::v-deep .multiselect__select:before {
  top: 50%;
  transform: translateY(-50%);
}

.catalog-modal-sort ::v-deep .multiselect__content-wrapper {
  border: 1px solid #cfd5df;
  border-radius: 8px;
  margin-top: 4px;
}

.catalog-modal-sort ::v-deep .multiselect__option {
  font-size: 13px;
  padding: 8px 12px;
  min-height: 36px;
}

.catalog-modal-sort ::v-deep .multiselect__option--highlight {
  background: #f1f5f9;
  color: #1e293b;
}

.catalog-modal-sort ::v-deep .multiselect__option--selected {
  background: var(--primaryColor, #3e416d);
  color: #fff;
  font-weight: 600;
}

/* ─── List header (super admin) ─── */
.catalog-list-header {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.catalog-list-header__title {
  margin: 0;
  font-size: 16px;
  min-width: 0;
}

.catalog-list-header__count {
  font-weight: 300;
}

.catalog-list-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.catalog-list-header__btn {
  white-space: nowrap;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

/* ─── Card item ─── */
.catalog-card {
  padding: 16px;
}

.catalog-card__row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

.catalog-card__check {
  position: relative;
  z-index: 2;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 42px 0 0;
  padding: 0;
  cursor: pointer;
}

.catalog-card__check input[type="checkbox"] {
  position: static;
  appearance: checkbox;
  -webkit-appearance: checkbox;
  display: block;
  opacity: 1;
  visibility: visible;
  width: 18px;
  height: 18px;
  margin: 0;
  padding: 0;
  pointer-events: auto;
  cursor: pointer;
}

.catalog-card__image {
  flex-shrink: 0;
  width: 180px;
}

.card-cover-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
}

.catalog-card__info {
  flex: 1;
  min-width: 0;
}

.catalog-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.catalog-card__title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px;
  word-break: break-word;
}

.catalog-card__badge--catalog {
  color: #36b37e;
  font-weight: 400;
  font-size: 13px;
}

.catalog-card__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.catalog-card__action-btn {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.catalog-card__meta {
  font-size: 13px;
  margin: 4px 0;
  color: #64748b;
}

.catalog-card__desc {
  font-size: 13px;
  margin: 4px 0;
  color: #475569;
}

.catalog-card__type {
  font-size: 13px;
  margin: 2px 0 0;
  color: #64748b;
}

/* ─── Normal admin card actions column ─── */
.catalog-card__actions-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.catalog-card__show-btn {
  white-space: nowrap;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.catalog-card__icon-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.catalog-card__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  border: none;
  border-radius: 8px;
  padding: 0;
  font-size: 16px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.catalog-card__icon-btn:active {
  transform: scale(0.95);
  opacity: 0.85;
}

.catalog-card__icon-btn--preview {
  background-color: #f5f5f5;
  color: #333;
}

.catalog-card__icon-btn--edit {
  background-color: #e0f7fa;
  color: #00796b;
}

.catalog-card__icon-btn--delete {
  background-color: #ffebee;
  color: #d32f2f;
}

/* ─── Share settings modal content ─── */
.catalog-share-content {
  background: #fff;
}

.catalog-share-content ::v-deep .row {
  margin-left: 0;
  margin-right: 0;
}

.catalog-share-content ::v-deep .ro {
  margin-left: 0;
  margin-right: 0;
}

/* ─── Share settings modal footer ─── */
.catalog-share-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.catalog-share-footer__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.catalog-share-footer__btn {
  white-space: nowrap;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  border-radius: 10px;
  font-weight: 600;
  padding: 8px 16px;
}

/* ─── Mobile (≤ 959px) ─── */
@media (max-width: 959px) {
  /* Hide desktop sidebar on mobile */
  .catalog-sidebar-desktop {
    display: none !important;
  }

  /* Search bar: stack */
  .catalog-search-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .catalog-search-bar__input {
    min-height: 48px;
    padding: 12px 16px;
    font-size: 16px;
  }

  .catalog-search-bar__select {
    width: 100%;
    min-width: 100%;
  }

  .catalog-search-bar__select ::v-deep .multiselect {
    min-height: 48px;
    height: 48px;
    font-size: 16px;
  }

  .catalog-search-bar__select ::v-deep .multiselect__tags {
    min-height: 48px;
    height: 48px;
    padding: 12px 40px 12px 16px;
    font-size: 16px;
  }

  .catalog-search-bar__select ::v-deep .multiselect__single {
    font-size: 16px;
  }

  .catalog-search-bar__select ::v-deep .multiselect__select {
    height: 48px;
    width: 44px;
  }

  .catalog-search-bar__select ::v-deep .multiselect__option {
    font-size: 16px;
    padding: 12px 16px;
    min-height: 48px;
  }

  .catalog-search-bar__select ::v-deep .multiselect__content-wrapper {
    border-radius: 10px;
  }

  /* List header: stack */
  .catalog-list-header {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 12px;
  }

  .catalog-list-header__title {
    font-size: 16px;
  }

  .catalog-list-header__actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .catalog-list-header__btn {
    flex: 1;
    min-height: 44px;
    font-size: 16px;
    padding: 10px 16px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  /* Card items: stack */
  .catalog-card {
    padding: 12px;
  }

  .catalog-card__row {
    flex-direction: column;
    gap: 10px;
  }

  .catalog-card__check {
    margin: 0;
    order: -1;
  }

  .catalog-card__image {
    width: 100%;
  }

  .card-cover-image {
    height: 180px;
    border-radius: 10px;
  }

  .catalog-card__info {
    width: 100%;
  }

  .catalog-card__header {
    flex-direction: column;
    gap: 8px;
  }

  .catalog-card__title {
    font-size: 16px;
  }

  .catalog-card__actions {
    flex-wrap: wrap;
    gap: 8px;
  }

  .catalog-card__action-btn {
    min-height: 44px;
    min-width: 44px;
    padding: 10px 12px;
    font-size: 16px;
    border-radius: 10px;
  }

  .catalog-card__meta,
  .catalog-card__desc,
  .catalog-card__type {
    font-size: 14px;
  }

  /* Normal admin actions column */
  .catalog-card__actions-col {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .catalog-card__show-btn {
    min-height: 44px;
    padding: 10px 16px;
    font-size: 16px;
    border-radius: 10px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .catalog-card__icon-btn {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    font-size: 18px;
    border-radius: 10px;
  }

  /* Share settings modal footer: remove full width, others space-between */
  .catalog-share-footer {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }

  .catalog-share-footer__right {
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex: 1 1 100%;
    justify-content: space-between;
  }

  .catalog-share-footer__btn {
    flex: 0 0 auto;
    min-width: 0;
    min-height: 48px;
    padding: 12px 20px;
    font-size: 15px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  /* Remove button full width on mobile */
  .catalog-share-footer > .catalog-share-footer__btn:first-child {
    width: 100%;
    flex: 1 1 100%;
  }

}

/* ─── Mobilde fullscreen modal ─── */
@media (max-width: 768px) {
  ::v-deep .app-modal--bottom-sheet {
    max-height: 100vh !important;
    height: 100vh;
    border-radius: 0;
  }
}

/* ─── Desktop hover ─── */
@media (hover: hover) and (pointer: fine) {
  .catalog-card__icon-btn--preview:hover {
    background-color: #e8e8e8;
  }

  .catalog-card__icon-btn--edit:hover {
    background-color: #b2ebf2;
  }

  .catalog-card__icon-btn--delete:hover {
    background-color: #ffcdd2;
  }

  .catalog-card__action-btn:hover {
    opacity: 0.85;
  }
}

/* ─── Reduced motion ─── */
@media (prefers-reduced-motion: reduce) {
  .catalog-card__icon-btn:active,
  .catalog-search-bar__dropdown-btn:active {
    transform: none;
  }
}
</style>
